import script from "./ResumePersonalStatement.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResumePersonalStatement.vue?vue&type=script&setup=true&lang=ts"

import "./ResumePersonalStatement.vue?vue&type=style&index=0&id=4cd8b3cc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cd8b3cc"]])

export default __exports__